import { Component, OnInit } from "@angular/core";

import { CoreConfigService } from "../../../../@core/services/config.service";
import { UtilsService } from "../../../auth/service/utils.service";
import { AuthenticationService, UserService } from "../../../auth/service";
import { Router } from "@angular/router";
import { TemplateDocumentService } from "../../../auth/service/template-document.service";
import { TutorialService } from "../../../auth/service/tutorial.service";
import { ICurrentUser } from "app/auth/models/user-interface";

@Component({
  selector: "app-documental",
  templateUrl: "./documental.component.html",
  styleUrls: ["./documental.component.scss"],
})
export class DocumentalComponent implements OnInit {
  public coreConfig: any;
  public currentUser: ICurrentUser;
  public acceptViewAllDocuments: boolean = false;
  public documentViewed: Array<number> = [];
  public documents_list: any = [];

  /**
     * Constructor
     *
     * @param {CoreConfigService} _coreConfigService
     *

     * @param _utilService
     * @param _userService
     * @param _authenticationService
     * @param _router
     * @param _templateDocumentService
     */
  constructor(
    private _coreConfigService: CoreConfigService,
    public _utilService: UtilsService,
    private _userService: UserService,
    private _authenticationService: AuthenticationService,
    private _router: Router,
    private _templateDocumentService: TemplateDocumentService,
    public _tutorialService: TutorialService,
  ) {
    this._utilService.disableAutoHideLoading();
    // Configure the layout
    this._coreConfigService.config = {
      layout: {
        navbar: {
          hidden: true,
        },
        menu: {
          hidden: true,
        },
        footer: {
          hidden: true,
        },
        customizer: false,
        enableLocalStorage: false,
      },
    };
  }

  async ngOnInit() {
    this.currentUser = this._authenticationService.getCurrentUser();
    if (this.currentUser && this.currentUser.send_onboarding === 1) {
      await this._router.navigateByUrl("/dashboard/main");
      this._utilService.hideLoading();
      return false;
    }
    this.documents_list = await this._templateDocumentService.getTemplateDocumentOnBoarding();

    if (!this.documents_list || (this.documents_list && this.documents_list.length < 1)) {
      await this.save();
    }
    await this._userService.get(this.currentUser.hash);
    this._utilService.hideLoading();
  }

  viewDocument(id: number) {
    if (!this.documentViewed.includes(id)) {
      this.documentViewed.push(id);
    }
  }

  async save() {
    this._utilService.showLoading();
    return this._userService
      .update(this.currentUser.hash, { send_onboarding: 1 })
      .then(async () => {
        await this._userService.getMe().then((result: any) => {
          result.capabilities = [];
          localStorage.setItem("currentUser", JSON.stringify(result));
          setTimeout(() => {
            this._utilService.hideLoading();
            this._router.navigateByUrl("/dashboard/main");
          }, 1000);
        });
      })
      .catch((err: any) => {
        console.error("err", err);
        this._utilService.hideLoading();
        this._utilService.showSWALError({ text: "ERROR_USER_DATA_INSERT" });
      });
  }

  showVideo() {
    this._tutorialService.video_to_play = "Onboarding";
    this._tutorialService.force_open_modal = true;
  }
}
